import React, { useState } from "react";
import * as yup from "yup";
import { FieldArray, Formik } from "formik";
import { Table } from "react-bootstrap";
import { DialogActions } from "@material-ui/core";
import { Alert } from "react-bootstrap";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import { CustomArrayTextField } from "../../../../../partials/content/Forms";
const itemReceiveSchema = yup.object().shape({
  qtyReceived: yup.number(),
  purchaseRequests: yup.array().of(
    yup.object().shape({
      qtyReserve: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Quantity is required")
        .min(1, "Quantity cannot be zero or empty")
        .default(0),
    })
  ),
});

function PrItemForm({
  itemReceive = {
    itemName: "",
    qtyReceived: 0,
    purchaseRequests: [
      {
        ID: 0,
        itemRequestID: 0,
        purchaseOrderID: 0,
        purchaseOrderItemID: 0,
        itemName: "",
        varCode: "",
        qty: 0,
        qtyReserve: 0,
        uomID: 0,
        uomName: "",
      },
    ],
  },
  onSaveData,
  onCloseDialog,
}) {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const data = {
    qtyReceived: itemReceive.qtyReceived,
    purchaseRequests: itemReceive.purchaseRequests,
  };
  return (
    <Formik
      initialValues={data}
      validationSchema={itemReceiveSchema}
      enableReinitialize={true}
      validateOnChange={false}
      onSubmit={(values) => {
        let totalQtyReserve = 0;
        for (const item of values.purchaseRequests) {
          totalQtyReserve += item.qtyReserve;
        }
        if (totalQtyReserve > values.qtyReceived) {
          setMessage(
            "Total Reserved Quantity is more than Total Received Quantity"
          );
          setShowMessage(true);
          return;
        }
        for (const pr of values.purchaseRequests) {
          pr.customerID = pr.itemRequest.salesOrder.customerID;
        }
        onSaveData(values.purchaseRequests);
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <React.Fragment>
          <form
            autoComplete="off"
            className="kt-form"
            onSubmit={handleSubmit}
            onKeyDown={onPreventEnterSubmitting}
          >
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                {showMessage ? (
                  <Alert
                    variant="danger"
                    onClose={() => {
                      setShowMessage(false);
                    }}
                    dismissible
                  >
                    {message}
                  </Alert>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <table className="table">
                  <tbody>
                    <tr>
                      <th>Item Name</th>
                      <th>:</th>
                      <td>{itemReceive.itemName}</td>
                    </tr>
                    <tr>
                      <th>Received Quantity</th>
                      <th>:</th>
                      <td>{itemReceive.qtyReceived}</td>
                    </tr>
                    <tr>
                      <th>Unit</th>
                      <th>:</th>
                      <td>{itemReceive.uomName}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <FieldArray name="purchaseRequests">
                  {({ push, remove }) => (
                    <div className="card">
                      <Table striped borderless hover size="sm" responsive="xl">
                        <thead>
                          <tr>
                            <th>Purchase Req ID</th>
                            <th>Item Request ID</th>
                            <th>Sales Order ID</th>
                            <th>Journey ID</th>
                            <th>Customer</th>
                            <th>Requested Quantity</th>
                            <th>Reserved Quantity</th>
                            <th>Unit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.purchaseRequests &&
                          values.purchaseRequests.length > 0
                            ? values.purchaseRequests.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{item.ID}</td>
                                    <td>{item.itemRequestID}</td>
                                    <td>{item.itemRequest.salesOrderID}</td>
                                    <td>{item.itemRequest.journeyID}</td>
                                    <td>
                                      {
                                        item.itemRequest.salesOrder.customer
                                          .customerName
                                      }
                                    </td>
                                    <td>{item.qty}</td>
                                    <td>
                                      <CustomArrayTextField
                                        arrayName="purchaseRequests"
                                        inputType="number"
                                        propertyName="qtyReserve"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        index={index}
                                        value={item}
                                        touched={touched}
                                        errors={errors}
                                      />
                                    </td>
                                    <td>{item.uom.uomName}</td>
                                  </tr>
                                );
                              })
                            : null}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </FieldArray>
              </div>
            </div>

            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={onCloseDialog}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            </DialogActions>
          </form>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default PrItemForm;
